{
  "source": "EXIOBASE 3.9.6, Region DE, Bezugsjahr 2022, AR6 GWP100 (ungewichteter Mittelwert der Sektoren)",
  "categories": {
    "metals": {
      "label": "Metalle & Halbzeuge",
      "kg_co2e_per_eur": 0.656,
      "sectors": {
        "Basic iron and steel and of ferro-alloys and first products thereof": 1.054,
        "Aluminium and aluminium products": 0.734,
        "Copper products": 0.529,
        "Fabricated metal products, except machinery and equipment (28)": 0.243,
        "Foundry work services": 0.723
      }
    },
    "components": {
      "label": "Komponenten & Elektrotechnik",
      "kg_co2e_per_eur": 0.437,
      "sectors": {
        "Machinery and equipment n.e.c. (29)": 0.182,
        "Electrical machinery and apparatus n.e.c. (31)": 0.517,
        "Radio, television and communication equipment and apparatus (32)": 0.287,
        "Medical, precision and optical instruments, watches and clocks (33)": 0.761
      }
    },
    "plastics": {
      "label": "Kunststoffe & Chemikalien",
      "kg_co2e_per_eur": 0.421,
      "sectors": {
        "Plastics, basic": 0.321,
        "Rubber and plastic products (25)": 0.282,
        "Chemicals nec": 0.662
      }
    },
    "packaging": {
      "label": "Verpackung & Papier",
      "kg_co2e_per_eur": 0.496,
      "sectors": {
        "Paper and paper products": 0.427,
        "Wood and products of wood and cork (except furniture); articles of straw and plaiting materials (20)": 0.566
      }
    },
    "agri": {
      "label": "Agrarrohstoffe",
      "kg_co2e_per_eur": 1.21,
      "sectors": {
        "Wheat": 0.766,
        "Cereal grains nec": 1.019,
        "Vegetables, fruit, nuts": 0.284,
        "Raw milk": 2.422,
        "Pigs": 0.707,
        "Poultry": 0.629,
        "Cattle": 2.644
      }
    },
    "food": {
      "label": "Lebensmittel & Zutaten",
      "kg_co2e_per_eur": 0.472,
      "sectors": {
        "Food products nec": 0.53,
        "Dairy products": 0.936,
        "Products of meat pigs": 0.273,
        "Products of meat poultry": 0.124,
        "Sugar": 0.374,
        "products of Vegetable oils and fats": 0.592
      }
    },
    "building": {
      "label": "Baustoffe",
      "kg_co2e_per_eur": 0.867,
      "sectors": {
        "Cement, lime and plaster": 1.242,
        "Bricks, tiles and construction products, in baked clay": 0.703,
        "Other non-metallic mineral products": 0.686,
        "Glass and glass products": 0.696,
        "Sand and clay": 1.262,
        "Stone": 0.616
      }
    },
    "goods": {
      "label": "Handelswaren",
      "kg_co2e_per_eur": 0.311,
      "sectors": {
        "Furniture; other manufactured goods n.e.c. (36)": 0.292,
        "Textiles (17)": 0.292,
        "Wearing apparel; furs (18)": 0.245,
        "Office machinery and computers (30)": 0.196,
        "Food products nec": 0.53
      }
    },
    "services": {
      "label": "IT- & Unternehmensdienstleistungen",
      "kg_co2e_per_eur": 0.088,
      "sectors": {
        "Computer and related services (72)": 0.048,
        "Other business services (74)": 0.114,
        "Research and development services (73)": 0.094,
        "Post and telecommunication services (64)": 0.096
      }
    },
    "logistics": {
      "label": "Transport & Logistik",
      "kg_co2e_per_eur": 0.43,
      "sectors": {
        "Other land transportation services": 0.175,
        "Railway transportation services": 0.168,
        "Sea and coastal water transportation services": 1.219,
        "Supporting and auxiliary transport services; travel agency services (63)": 0.159
      }
    },
    "air_travel": {
      "label": "Flugreisen",
      "kg_co2e_per_eur": 0.441,
      "sectors": {
        "Air transport services (62)": 0.441
      }
    },
    "hotels": {
      "label": "Hotels & Gastronomie",
      "kg_co2e_per_eur": 0.202,
      "sectors": {
        "Hotel and restaurant services (55)": 0.202
      }
    }
  }
}
